export const isDueDateSort = (sort) => sort === "dueDate" || sort === "-dueDate";

// Both directions are ordered locally using the deadlines displayed on the cards.
export const getCourseRequestFilters = (filters, myLearning) =>
    myLearning && isDueDateSort(filters.sort) ? { ...filters, sort: "dueDate" } : filters;

export const loadCoursePages = async ({ fetchPage, cursor, allPages, isCurrent, onPage }) => {
    const data = [];
    const included = [];
    let links = {};
    let nextCursor = cursor;
    const visited = new Set();
    do {
        if (visited.has(nextCursor)) throw new Error("Course pagination repeated a cursor.");
        visited.add(nextCursor);
        const response = await fetchPage(nextCursor);
        if (!isCurrent()) return null;
        data.push(...(response.data || []).filter((item) =>
            item?.attributes?.localizedMetadata &&
            !item.attributes.localizedMetadata[0]?.name.includes("DNS") &&
            !item.attributes.tags?.some((tag) => tag.includes("DNS"))
        ));
        included.push(...(response.included || []));
        links = response.links || {};
        nextCursor = links.next
            ? new URL(links.next, window.location.origin).searchParams.get("page[cursor]")
            : null;
        if (onPage) onPage({ data, included, links, nextCursor });
    } while (nextCursor && (allPages || data.length < 10));
    return { data, included, links, nextCursor };
};

export const sortCoursesByDueDate = (courses, sort) => {
    if (!isDueDateSort(sort)) return courses;

    const direction = sort === "dueDate" ? 1 : -1;
    return [...courses].sort((a, b) => {
        const first = Date.parse(a.dueDate);
        const second = Date.parse(b.dueDate);
        if (!Number.isFinite(first)) return Number.isFinite(second) ? 1 : 0;
        if (!Number.isFinite(second)) return -1;
        return direction * (first - second);
    });
};
